<template>
  <div>
    <layout headerTitle="Sistema de vigilancia epidemiológico">
      <template #container>
        <b-row class="pt-4 pb-5">
          <div style="display: flex; left: 15px; margin-bottom: 10px">
            <label class="mr-2 breadcrumb-link"
              ><button
                class="mt-0 p-0 pb-1 d-flex align-items-center breadcrumb-link back"
                style="
                  border: none;
                  background-color: transparent;
                  font-size: 16px;
                "
                @click.prevent="back"
              >
                Volver atrás
              </button></label
            >
          </div>
          <b-col cols="12">
            <img
              alt="group"
              :src="require('@/assets/modules/health-tracker/icon/group.svg')"
            />
            <strong class="pl-2">{{ nameForm }} Calificación</strong>
          </b-col>
        </b-row>

        <b-row class="mb-5">
          <b-col cols="12">
            <strong>Datos del trabajador</strong>
            <worker-information :id="employeeId" />
          </b-col>
        </b-row>

        <!-- opciones -->
        <FormDetailQualification
          @changeForm="changeForm"
          :entities="entities"
          :loading="loading"
          :isEdit="isEdit"
          :isBusy="isBusy"
          :record="record"
        />
        <FormDetailInvestigation
          @changeForm="changeForm"
          :loading="loading"
          :isEdit="isEdit"
          :isBusy="isBusy"
          :record="record"
          :isDetailInvestigation="isDetailInvestigation"
          v-if="isDetailInvestigation"
        />

        <hr class="hr-form-ipt" />
        <b-row class="mt-5" v-if="isValidation && !loading && !isEdit">
          <b-col cols="12">
            <b-alert show variant="danger" class="alert-danger-form-ipt">
              <div class="d-flex align-items-center">
                <div class="mr-3">
                  <img
                    src="@/assets/images/icons/icon-danger.svg"
                    alt=""
                    width="28px"
                    height="28px"
                  />
                </div>
                <p
                  style="
                    font-size: 16px;
                    color: #ac0000;
                    margin-bottom: 0;
                    font-weight: 400;
                  "
                >
                  Para guardar una calificación es necesario llenar los campos y
                  documentos requeridos *.
                </p>
              </div>
            </b-alert>
          </b-col>
        </b-row>

        <div
          class="mt-5 d-flex justify-content-end mb-5"
          v-if="!loading && !isEdit"
        >
          <button
            class="button_primary"
            @click.prevent="saveQualification"
            :disabled="isBusy || isValidation"
          >
            Guardar {{ !record ? "calificación" : "cambios" }}
            <b-spinner v-if="isBusy" />
          </button>
        </div>
      </template>
    </layout>
    <!-- 3 MODAL PROCESO EXITOSO  -->
    <modal-success :messageModal="messageModal" />

    <!-- 4 MODAL PROCESO FALLIDO -->
    <modal-error :error="error" />
  </div>
</template>
<script>
import FormDetailQualification from "./components/FormDetailQualification.vue";
import FormDetailInvestigation from "./components/FormDetailInvestigation.vue";
import ModalSuccess from "@/views/SVE/modals/ModalSuccess.vue";
import ModalError from "@/views/SVE/modals/ModalError.vue";
import {
  getInfoSelect,
  saveQualification,
  detailQualification,
  editQualification,
} from "@/services/health-tracker/diagnostic/service";
export default {
  name: "createQualification",
  components: {
    layout: () => import("@/layouts/modules/health-tracker/v2/app.vue"),
    WorkerInformation: () =>
      import(
        "@/components/Modules/HealthTracker/V2/Common/WorkerInformation/WorkerInformation.vue"
      ),
    FormDetailQualification,
    FormDetailInvestigation,
    ModalSuccess,
    ModalError,
  },
  data() {
    return {
      isBusy: false,
      isDetailInvestigation: false,
      messageModal: "Calificación guardada exitosamente",
      error: {
        message: "",
      },
      entities: [],
      formData: {
        claim_type: null,
        qualification_date: "",
        structuring_date: "",
        responsible_entity: null,
        medical_improvement: null,
        qualification_status: null,
        qualification_observations: null,
        medical_improvement_file: null,
        disease_investigated: null,
        eps_notification: null,
        research_observations: null,
        investigation_file: null,
        furel_file: null,
        ministry_notification_file: null,
        eps_notification_file: null,
      },
      isEdit: false,
      loading: false,
      record: null,
    };
  },
  computed: {
    employeeId() {
      return parseInt(this.$route.params.employee_id || "0");
    },
    diagnosticId() {
      return parseInt(this.$route.params.diagnostic_id || "0");
    },
    qualificationId() {
      return parseInt(this.$route.params.qualitication_id || "0");
    },
    isValidation() {
      const me = this;
      let isValidation = true;

      isValidation =
        me.formData.claim_type?.id &&
        me.formData.responsible_entity?.id &&
        me.formData.medical_improvement?.id &&
        me.formData.qualification_status?.id &&
        me.formData.qualification_date !== "" &&
        me.formData.structuring_date !== "" &&
        me.formData.qualification_observations !== null &&
        me.formData.qualification_observations !== ""
          ? false
          : true;

      if (
        me.record == null &&
        me.formData.disease_investigated &&
        me.formData.disease_investigated?.id === "1"
      ) {
        isValidation =
          me.formData.investigation_file == null ||
          me.formData.furel_file == null ||
          me.formData.ministry_notification_file == null
            ? true
            : false;
      }

      if (
        me.record == null &&
        me.formData.eps_notification &&
        me.formData.eps_notification?.id === "1"
      ) {
        isValidation = me.formData.eps_notification_file == null ? true : false;
      }

      return isValidation;
    },
    nameForm() {
      const me = this;
      let text = "Nueva";
      if (me.qualificationId > 0 && !me.isEdit) {
        text = "Editar";
      } else if (me.qualificationId > 0 && me.isEdit) {
        text = "Detalle";
      }
      return text;
    },
  },
  methods: {
    async saveQualification() {
      const me = this;
      me.isBusy = true;
      const formData = me.parseData();
      try {
        me.record ? await editQualification(formData, me.qualificationId) : await saveQualification(formData) ;
        me.$bvModal.show("modal-success");
        setTimeout(() => {
          me.back();
        }, 5000);
      } catch (error) {
        console.log(error);
        me.error.message = "Error al guardar Formulario";
        me.$bvModal.show("modal-fail");
      } finally {
        me.isBusy = false;
      }
    },
    changeForm(formData) {
      const me = this;
      me.formData = {
        ...me.formData,
        ...formData,
      };
      me.isDetailInvestigation =
        me.formData.claim_type?.id === 1 || me.formData.claim_type?.id === 3;
      
      if (!me.isDetailInvestigation) {
        me.formData.eps_notification = null;
        me.formData.research_observations = null;
        me.formData.investigation_file = null;
        me.formData.furel_file = null;
        me.formData.ministry_notification_file = null;
        me.formData.eps_notification_file = null;
      }
    },
    async loadEntities() {
      const me = this;
      me.entities = [];
      me.loading = true;
      try {
        const { data } = await getInfoSelect("responsible_entity");
        data?.forEach((x) => {
          me.entities.push({
            id: x.id,
            name: x.info,
          });
        });
      } catch (error) {
        console.log(error);
      } finally {
        me.loading = me.qualificationId > 0 ? true : false;
      }
    },
    parseData() {
      const me = this;
      const formData = new FormData();
      formData.append("diagnostic_id", me.diagnosticId);
      me.formData.claim_type !== null &&
        formData.append("claim_type", me.formData.claim_type?.id || null);
      me.formData.qualification_date !== "" &&
        formData.append("qualification_date", me.formData.qualification_date);
      me.formData.structuring_date !== "" &&
        formData.append("structuring_date", me.formData.structuring_date);
      me.formData.responsible_entity !== null &&
        formData.append(
          "responsible_entity",
          me.formData.responsible_entity?.id || null
        );
      me.formData.medical_improvement !== null &&
        formData.append(
          "medical_improvement",
          me.formData.medical_improvement?.id == "1" ? "1" : "0"
        );
      me.formData.qualification_status !== null &&
        formData.append(
          "qualification_status",
          me.formData.qualification_status?.id || null
        );
      me.formData.qualification_observations !== null &&
        formData.append(
          "qualification_observations",
          me.formData.qualification_observations
        );
      me.formData.disease_investigated !== null &&
        formData.append(
          "disease_investigated",
          me.formData.disease_investigated?.id == "1" ? "1" : "0"
        );
      me.formData.eps_notification !== null &&
        formData.append(
          "eps_notification",
          me.formData.eps_notification?.id == "1" ? "1" : "0"
        );
      me.formData.research_observations !== null &&
        formData.append(
          "research_observations",
          me.formData.research_observations
        );
      me.formData.investigation_file !== null &&
        formData.append(
          "files[investigation_file]",
          me.formData.investigation_file
        );
      me.formData.furel_file !== null &&
        formData.append("files[furel_file]", me.formData.furel_file);
      me.formData.ministry_notification_file !== null &&
        formData.append(
          "files[ministry_notification_file]",
          me.formData.ministry_notification_file
        );
      me.formData.eps_notification_file !== null &&
        formData.append(
          "files[eps_notification_file]",
          me.formData.eps_notification_file
        );
      me.formData.medical_improvement_file !== null &&
        formData.append(
          "files[medical_improvement_file]",
          me.formData.medical_improvement_file
        );

      return formData;
    },
    back() {
      const me = this;
      me.$router.push({
        name: "listQualification",
        params: {
          employee_id: me.employeeId,
          diagnostic_id: me.diagnosticId,
        },
      });
    },
    async loadQualification() {
      const me = this;
      me.record = null;
      me.loading = true;
      try {
        const { result } = await detailQualification(me.qualificationId);
        me.record = result;
      } catch (error) {
        console.log(error);
      } finally {
        me.loading = false;
      }
    },
  },
  async mounted() {
    const me = this;
    const params = me.$route.params.is_edit || null;
    me.isEdit = params && params !== 'false' ? false : true;
    await me.loadEntities();
    if (me.qualificationId > 0) me.loadQualification();
    // if (me.employeeId < 1)
    //   return me.$router.push({ name: "errorPage", params: { code: 400 } });
  },
};
</script>
<style lang="scss">
.alert-danger-form-ipt {
  border: 1px solid #ac0000 !important;
  border-radius: 4px !important;
  background-color: #ffdfdf !important;
  margin-bottom: 40px;
}
.hr-form-ipt {
  border-bottom: 1px solid #c9caff !important;
  margin: 16px 0 !important;
}
.breadcrumb-link {
  color: #5d5fef;
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  margin-top: 0.125em;
}
</style>
